import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Blog from "../Allcomponent/blog"
function Mainblog(){
    return(
        <>
        <Banner/>
        <Cards/>
        <Blog/>
        
        </>
    )
}
export default Mainblog